<script>
  import "./27types.css";

  import { Router, Route, Link } from "svelte-routing";

  import Page from "./ponents/Page.svelte";
  import Home from "./quasaipages/Home.svelte";
  import Result from "./quasaipages/Results.svelte";
  import Catalog from "./quasaipages/Catalog.svelte";
  import Statistics from "./quasaipages/Statistics.svelte";

  export let url = "";

  let scrollPixY = window.scrollY;

  window.addEventListener(
    "scroll",
    (e) => {
      scrollPixY = window.scrollY;
    },
    { passive: true }
  );

  import FastPoissonDiskSampling from "fast-2d-poisson-disk-sampling";

  const FLOATERS_BREADTH = 3000;
  const FLOATERS_SHIFT = -1500;
  var p = new FastPoissonDiskSampling({
    shape: [FLOATERS_BREADTH, FLOATERS_BREADTH],
    radius: 250,
    tries: 10,
  });
  var points = p.fill();

  const REQUEST_DESKTOP_WEBSITE =
    navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
  if (REQUEST_DESKTOP_WEBSITE) {
    document
      .querySelector(
        "meta[name='viewport'][content='width=device-width,height=device-height,initial-scale=1']"
      )
      .setAttribute(
        "content",
        "width=device-width,height=device-height,initial-scale=0.25"
      ) /*.remove()*/;
  }

  import { adsConfig } from "./stores/Store";
</script>

<!--svelte:head>
  {#if Math.random() <= 0.001}
    <meta
      http-equiv="refresh"
      content="10;url=https://www.pornhub.com/gayporn"
    />
  {/if}
</svelte:head-->

<Router {url}>
  <aside class="background">
    {#each points as coordinates, i}
      {@const iconsNames = [
        "skull",
        "smiley-poop",
        "handshake",
        "walker",
        "heart",
        "drug",
        "emoji-kiss",
      ]}
      {@const emojis = [
        "🤣",
        "😎",
        "💊",
        "💔",
        "❤️",
        "😂",
        "😆",
        "☠️",
        "😈",
        "🙅",
        "🚬",
        "⚰️",
        "☣️",
        "🤓",
        "🍆",
        "💦",
        "🍑",
        "🔫",
        "💉",
        "🩸",
      ]}
      {@const randChoice = (arr) => arr[Math.floor(arr.length * Math.random())]}
      {@const depth = 10 + 90 * Math.random()}
      {@const smoothStep = (x) => x ** 2 * (3 - 2 * x)}
      <span
        style="transform: translate3d({FLOATERS_BREADTH *
          smoothStep(coordinates[0] / FLOATERS_BREADTH) +
          FLOATERS_SHIFT}%,{coordinates[1] +
          FLOATERS_SHIFT}%,-{depth}px); top:{-scrollPixY}px; filter: blur({Math.max(
          0,
          depth - 50
        ) / 1000}em);">{randChoice(emojis)}</span
      >
    {/each}
  </aside>
  <div class="container">
    <Route path="/"><Page><Home /></Page></Route>
    <Route path="/results"><Page><Result /></Page></Route>
    <Route path="/catalog"><Page><Catalog /></Page></Route>
    <Route path="/statistics"><Page><Statistics /></Page></Route>
  </div>

  {#if $adsConfig.footerBanner}
    <!--div>
      <hr />
      <div class="ad-banner">
        <script
          async
          type="application/javascript"
          src="https://a.magsrv.com/ad-provider.js"
        ></script>
        <ins class="eas6a97888e2" data-zoneid="5548580"></ins>
        <script>
          (AdProvider = window.AdProvider || []).push({ serve: {} });
        </script>
      </div>
    </div-->
  {/if}

  <div class="container">
    <footer class="text-muted">
      <hr />
      <small>&copy; Copyright 2022&ndash;2025 <em>27types</em></small>
      <br />
      <small>
        Built with <em>Svelte</em>, <em>Bootstrap</em>,
        <em>Amazon Web Services</em>, &amp;
        <em>Netlify</em>
      </small>
    </footer>
  </div>

  {#if $adsConfig.interstitial}
    <!--script
      async
      type="application/javascript"
      src="https://a.pemsrv.com/ad-provider.js"
    ></script>
    <ins class="eas6a97888e33" data-zoneid="5548582"></ins>
    <script>
      (AdProvider = window.AdProvider || []).push({ serve: {} });
    </script-->
  {/if}
</Router>
